import * as React from 'react';

import {
    HeaderProps,
} from './headerprops';

import Row from 'antd/lib/row';
import Col from 'antd/lib/col';

/**
 * Header displyed on top of page
 * @topnavigation contains left most items though JSX Elements enclosed in  topnavigation tag
 * @useravigation contains right most items though JSX Elements encolsed in  usernavigation tag
 */

export const HeaderBar = ({
    topnavigation,
    usernavigation,
    topClassName= 'header__main',
    userClassName ='header__aside',
}: HeaderProps) => (
    <div className="='header'">
    <Row type="flex" justify="space-between" align="middle">
      <Col className={topClassName}>
        {topnavigation}
      </Col>
      <Col className={userClassName}>
        {usernavigation}
      </Col>
    </Row>
  </div>
    );
